export enum EVariableIncomeAcquisitionSteps {
  TEMPLATE,
  INVESTMENT,
  PREVIEW,
  CONCLUSION
}
